<template>
   <CollapseCard
      v-if="progress !== null"
      :ident="`${ident}-card`"
      class="mb-0 customer-dashboard-card"
   >
      <template #title>
         <div class="d-flex align-items-center section-title">
            <span class="progress-card-title">{{ title }}</span>
         </div>
      </template>
      <template #subtitle>
         <div class="d-flex align-items-center">
            <span :id="`${ident}-percentage`" class="mr-2 progress-card-percentage">
               {{ progress || 0 }}% Complete
            </span>
            <b-progress
               :value="progress"
               :max="100"
               class="section-progress"
               :variant="isComplete ? 'success' : 'primary'"
            >
            </b-progress>
         </div>
      </template>

      <slot name="header"></slot>

      <slot>
         <b-table
            :fields="actionFields"
            :items="actionItems"
            sort-icon-left
            :id="`table-${ident}-action`"
            class="mb-0 scrollbar"
            show-empty
            responsive
            sticky-header="500px"
         >
            <template #cell(actions)="data">
               <div class="cell-w-buttons d-flex justify-content-end">
                  <b-button
                     :id="`btn-${ident}-action`"
                     variant="success"
                     class="no-wrap d-flex align-items-center action-button"
                     size="sm"
                     @click="toAction(data.item.to, data.item.studyId)"
                  >
                     {{ data.item.buttonText }}
                     <custom-icon
                        icon="icon-chevron-right"
                        height="16px"
                        width="16px"
                        class="ml-1"
                     />
                  </b-button>
               </div>
            </template>

            <template #empty>
               <div class="text-center py-4">You have no active items</div>
            </template>
         </b-table>

         <b-table
            v-if="completedActionItems.length > 0"
            :fields="completedActionFields"
            :items="completedActionItems"
            sort-icon-left
            :id="`table-${ident}-completed`"
            class="mb-0 mt-3 scrollbar collapse-card-table"
            responsive
            sticky-header="500px"
         >
            <template #cell(actions)="data">
               <div class="cell-w-buttons d-flex justify-content-end">
                  <b-button
                     v-if="data.item.buttonText"
                     variant="primary"
                     class="no-wrap dark-button action-button"
                     size="sm"
                     @click="toAction(data.item.to, data.item.studyId)"
                     >{{ data.item.buttonText }}</b-button
                  >
               </div>
            </template>
         </b-table>
      </slot>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   props: {
      ident: {
         type: String,
      },

      title: {
         type: String,
      },

      progress: {
         type: Number,
      },

      actionItems: {
         type: Array,
         default: () => [],
      },

      completedActionItems: {
         type: Array,
         default: () => [],
      },
   },

   computed: {
      ...mapGetters({
         openStudies: 'companies/openStudies',
         studyMap: 'companies/studyMap',
         activeStudyId: 'companies/activeStudyId',
      }),

      actionFields() {
         const fields = [
            {key: 'text', label: 'Incomplete', sortable: true, class: 'text-table-field'},
            {key: 'actions', label: ''},
         ];
         if (this.openStudies.length > 1) {
            fields.unshift({
               key: 'studyId',
               label: 'Study',
               class: 'text-table-field',
               formatter: (value) => this.studyMap[value]?.label,
               sortable: true,
               sortByFormatted: true,
            });
         }
         return fields;
      },

      completedActionFields() {
         const fields = [
            {key: 'text', label: 'Completed', sortable: true, class: 'text-table-field'},
            {key: 'actions', label: ''},
         ];
         if (this.openStudies.length > 1) {
            fields.unshift({
               key: 'studyId',
               label: 'Study',
               class: 'text-table-field',
               formatter: (value) => this.studyMap[value]?.label,
               sortable: true,
               sortByFormatted: true,
            });
         }
         return fields;
      },

      isComplete() {
         return this.progress === 100;
      },
   },

   methods: {
      async toAction(route, studyId) {
         if (this.activeStudyId != studyId) {
            this.$store.commit('companies/setActiveStudy', studyId);
         }
         if (route.params?.shouldOpenTaxReturnModal) {
            this.$store.commit('setTaxReturnModalOpened', true);
         }
         this.$router.push(route);
      },
   },
};
</script>

<style lang="scss" scoped>
.customer-dashboard-card {
   margin-bottom: 0;
}

.progress-card-title {
   font-size: 0.8125rem;
   font-weight: 700;
}

.progress-card-percentage {
   font-size: 0.8125rem;
}

::v-deep .text-table-field {
   font-size: 0.8125rem;
}

.action-button {
   font-size: 0.75rem;
}

.section-title {
   @include lg-max {
      font-size: 1.25rem;
   }
}

.section-progress {
   min-width: 7rem;
   @include lg {
      min-width: 14rem;
   }
}
</style>
